import Raven from 'raven-js';
import anonymousStorage from 'usage-tracker-core/containers/anonymousStorage';
import { getDeviceId, getUtk } from 'usage-tracker-core/common/defaultTrackers';
import { getAndRefreshHamplitudeProperties } from 'usage-tracker-core/metaProperties';
import { createContainer } from 'usage-tracker-multi';
import { withSessionReplay } from 'usage-tracker-session-replay';
import { getCookie } from '../utils/getCookie';
import { setUtAnonId } from '../utils/windowGlobals';
const CATEGORY_PREFERENCES_COOKIE = '__hs_cookie_cat_pref';
const OPT_OUT_COOKIE = '__hs_opt_out';
const LABORATORY_IDENTIFIER_META_TAG = 'meta[name="laboratory-identifier-other"]';
function getAnonymousDeviceId() {
  const metaElement = document.querySelector(LABORATORY_IDENTIFIER_META_TAG);
  const laboratoryIdentifier = (metaElement === null || metaElement === void 0 ? void 0 : metaElement.getAttribute('content')) || undefined;
  const {
    device_id
  } = getAndRefreshHamplitudeProperties(anonymousStorage.getItem, anonymousStorage.setItem, {
    currentTime: Date.now(),
    deviceId: laboratoryIdentifier
  });
  return device_id;
}
function hasAcceptedCookies() {
  return getUtk() && (getCookie(CATEGORY_PREFERENCES_COOKIE).includes('1:true') || getCookie(OPT_OUT_COOKIE) === 'no');
}

// usage-tracker-session-replay requires IndexedDB. Headless crawlers (e.g.
// Lightpanda) lack it, causing unhandled "Remote config fetch rejected" errors.
export function isSessionReplaySupported() {
  try {
    return typeof window !== 'undefined' && Boolean(window.indexedDB);
  } catch (_unused) {
    return false;
  }
}
const {
  createTracker
} = createContainer({
  storeUuidOnUrl: false
});
export function createPublicTracker() {
  const tracker = createTracker({
    standalone: true,
    properties: {
      namespace: 'pricing-pages',
      hstc: () => `x.${hasAcceptedCookies() ? getUtk() : getAnonymousDeviceId()}`
    },
    lastKnownEventProperties: ['screen', 'subscreen', 'useCases', 'teamSize', 'selectedContactsCount'],
    onError: (err, options = {}) => {
      Raven.captureException(err, Object.assign({}, options));
    },
    trackerType: hasAcceptedCookies() ? 'public' : 'anonymous',
    onBeforeSwitch: ({
      to
    }) => {
      setUtAnonId(to === 'anonymous' ? getAnonymousDeviceId() : getDeviceId());
    }
  });
  return isSessionReplaySupported() ? withSessionReplay(tracker) : tracker;
}